__turbopack_context__.v({
  "aqua": "StatusIndicator-module-scss-module__SsjJxa__aqua",
  "blue": "StatusIndicator-module-scss-module__SsjJxa__blue",
  "cyan": "StatusIndicator-module-scss-module__SsjJxa__cyan",
  "emerald": "StatusIndicator-module-scss-module__SsjJxa__emerald",
  "gray": "StatusIndicator-module-scss-module__SsjJxa__gray",
  "green": "StatusIndicator-module-scss-module__SsjJxa__green",
  "indigo": "StatusIndicator-module-scss-module__SsjJxa__indigo",
  "l": "StatusIndicator-module-scss-module__SsjJxa__l",
  "m": "StatusIndicator-module-scss-module__SsjJxa__m",
  "magenta": "StatusIndicator-module-scss-module__SsjJxa__magenta",
  "moss": "StatusIndicator-module-scss-module__SsjJxa__moss",
  "orange": "StatusIndicator-module-scss-module__SsjJxa__orange",
  "pink": "StatusIndicator-module-scss-module__SsjJxa__pink",
  "red": "StatusIndicator-module-scss-module__SsjJxa__red",
  "s": "StatusIndicator-module-scss-module__SsjJxa__s",
  "statusIndicator": "StatusIndicator-module-scss-module__SsjJxa__statusIndicator",
  "violet": "StatusIndicator-module-scss-module__SsjJxa__violet",
  "yellow": "StatusIndicator-module-scss-module__SsjJxa__yellow",
});
